import { useEffect, useRef, useState } from 'react';

import { ComponentDimensions } from '../../../types/Layout';
import { Tabs } from '../types';

import Candles from './Candles';
import SingleProfitCalculation from './SingleProfitCalculation';

import './index.css';
import {
  ProfitByPeriodApiResponse,
  ProfitCalculationProfitData,
} from '../../Detail/Charts/types';
import ComplexParamsCalculation from './ComplexParamsCalculation';
import CalculationResultHistory from './CalculationResultHistory';

interface Props {
  activeTab: Tabs;
  setProfitByPeriodData: React.Dispatch<
    React.SetStateAction<ProfitByPeriodApiResponse | undefined>
  >;
  setProfitData: React.Dispatch<
    React.SetStateAction<ProfitCalculationProfitData | undefined>
  >;
}

const Content = (props: Props) => {
  const { activeTab, setProfitByPeriodData, setProfitData } = props;

  const [rootDimensions, setRootDimensions] = useState<
    ComponentDimensions | undefined
  >(undefined);
  const rootRef = useRef<any>(null);

  useEffect(() => {
    if (!!rootDimensions) {
      return;
    }

    if (!rootRef.current) {
      return;
    }

    setRootDimensions({
      height: rootRef.current.clientHeight, // - 60 - 40 + 15 - 90, // 60 = options height, 40 = marginTop of options, 15 = -marginBottom, 280 candles form
      width: rootRef.current.clientWidth - 30,
    });
  }, [rootDimensions]);

  return (
    <div className="candles-content" ref={rootRef}>
      {activeTab === Tabs.Candles && rootDimensions && (
        <Candles rootDimensions={rootDimensions} />
      )}
      {activeTab === Tabs.SingleProfitCalculation && (
        <SingleProfitCalculation
          setProfitByPeriodData={setProfitByPeriodData}
          setProfitData={setProfitData}
        />
      )}
      {activeTab === Tabs.ComplexParamsCalcultion && (
        <ComplexParamsCalculation
          setProfitByPeriodData={setProfitByPeriodData}
          setProfitData={setProfitData}
        />
      )}
      {activeTab === Tabs.CalculationResultHistory && (
        <CalculationResultHistory
          setProfitByPeriodData={setProfitByPeriodData}
          setProfitData={setProfitData}
        />
      )}
    </div>
  );
};

export default Content;
